import { Injectable } from '@angular/core';

import {
  AbstractGraphNodeBuilder,
  DeclarativeFieldComponent,
  FieldNodeInputDefinitionList,
  GraphBuilderContext,
} from '@fmnts/declarative-forms';
import {
  FieldOperatorName,
  FormOperatorName,
} from '@fmnts/declarative-forms/common';
import { TranslationService } from '@fmnts/i18n';

import { NextFieldKey } from '../next-form-known-fields';

export enum LocalizationNodeName {
  FormLanguage = 'l10n.form-language$',
}

/**
 * Graph that emits with the selected form language in case that
 * it is part of the available language items and as long as the
 * control wasn't changed by the user.
 *
 * It will also preserve the last emitted value as the default
 * value on form resets and page reloads.
 */
const fakeCorrespondenceLanguageDefinitions: FieldNodeInputDefinitionList = {
  value: {
    name: LocalizationNodeName.FormLanguage,
    pipe: [
      {
        operator: FieldOperatorName.FilterValueInItems,
      },
      { operator: FormOperatorName.FieldRestoreAsDefault },
      {
        operator: FormOperatorName.FieldFilterUiState,
        args: ['pristine'],
      },
    ],
  },
};

/**
 * Builder for localization related graph nodes
 */
@Injectable()
export class LocalizationGraphNodeBuilder extends AbstractGraphNodeBuilder<
  LocalizationNodeName,
  string
> {
  constructor(private translation: TranslationService) {
    super();

    // ***********************
    // Register source nodes
    // ***********************
    this.addNode(LocalizationNodeName.FormLanguage, () => this.formLanguage$());
  }

  /**
   * @returns
   * An `Observable` that emits with the form language
   */
  private formLanguage$() {
    return this.translation.currentLanguage$.asObservable();
  }

  createFakeDefinitions(ctx: GraphBuilderContext) {
    const genericComponent = ctx.injector.get(DeclarativeFieldComponent, null);

    switch (genericComponent?.field?.key) {
      case NextFieldKey.CorrespondenceLanguage:
        return fakeCorrespondenceLanguageDefinitions;
    }
  }
}
